import type { AxiosResponse } from 'axios'
import { ApiService } from '~/shared/api'
import type { DigitalLectureSpeakerDto } from '~/models/digital-lecture'
import { API_PREFIX } from '~/shared/const/request-services'

export class DigitalLectureSpeakerAppService extends ApiService {
  readonly url = `${API_PREFIX}/digital-lecture/speakers`

  sendApplication(dto: DigitalLectureSpeakerDto): Promise<AxiosResponse> {
    return this.http.request({
      method: 'POST',
      data: dto,
      url: this.url,
      silent: true,
    })
  }
}
